import React from 'react';

function LargeTextBox(){
    return (
        <div><p>textbox</p></div>
    )

}

export default LargeTextBox;